import {connect} from "react-redux";
import {mapStateToProps} from "../../store/helpers/mapState";
import {mapDispatchToProps} from "../../store/helpers/mapDispatch";
import DatatableComponent from "../../helpers/DatatableComponent";
import moment from "moment";
import { Chip } from "@mui/material";


function FinanceDeliverables({location}) {

    const  columns = [
        {
            name:"title",
            label:"Name"
        },
        {
            name:"project.name",
            label:"Project Name"
        },
        {
            name:"amount",
            label:"Amount",
            options:{
                customBodyRender:(v)=>v?.toLocaleString()
            }
        },
        {
            name:"startDate",
            label:"Start Date",
            options:{
                customBodyRender:(v)=>moment(v).format("YYYY-MMM-DD")
            }
        },
        {
            name:"endDate",
            label:"End Date",
            options:{
                customBodyRender:(v)=>moment(v).format("YYYY-MMM-DD")
            }
        },
        {
            name: "status",
            label: "Progress Status",
            options: {
                customBodyRender: (v) => <Chip label={v} />
            }
        },
        {
            name: "paymentStatus",
            label: "Payment Status",
            options: {
                customBodyRender: (v) => <Chip label={v} />
            }
        },
    ];

    return <div>
        <DatatableComponent columns={columns} elevation={1} title={`Deliverables (${location?.state?.quarter ? `${location?.state?.quarter??''} Quarter, ` : ''}${location?.state?.paymentStatus?`${location?.state?.paymentStatus === 'PAID' ? 'Paid Deliverables' : 'Unpaid Deliverables'}` : ''})`} url={`/api/finance/dashboard/deliverables/?quarter=${location?.state?.quarter??''}&amountType=${location?.state?.currency??''}&paymentStatus=${location?.state?.paymentStatus ??''}`}/>
    </div>;
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceDeliverables);
